<style scoped>
  .small {
    height: 320px;
    /*max-height: 250px;*/
    /*max-width: 600px;*/
    /*max-height: 500px;*/
    /*margin:  10px auto;*/
  }
  .monitor {
    width: 100%;
    text-align: center;
  }
  .monitorDesc {
    font-size: 20px;
    color: #585b80;
  }
  .monitorBox {
    height: 250px;
    width: 100%;
  }
</style>

<template>
    <div class="small" style="margin-top: 20px;">
      <div v-if="ready">
          <LineChart :height="250" :chartData="chartData" :options="chartOptions"/>
        <div style="text-align: center; margin-top: 20px">
          <RadioGroup v-model="interval"  type="button" size="small" @on-change="updateValueChart">
            <Radio label="1" style="font-size: 12px">{{ $text.tr('МЕСЯЦ') }}</Radio>
            <Radio label="3" style="font-size: 12px">{{ $text.tr('3 МЕСЯЦА') }}</Radio>
            <Radio label="ALL" style="font-size: 12px">{{ $text.tr('ВСЕ ВРЕМЯ') }}</Radio>
          </RadioGroup>
        </div>
      </div>
        <table v-else class="monitorBox">
          <tr>
            <td class="monitor">
              <img src="../../../assets/monitor.svg" width="250px" height="160px"><br>
              <span class="monitorDesc">{{ $text.tr('Данные для графика собираются') }}...</span>
            </td>
          </tr>
        </table>
  </div>
</template>

<script>
import LineChart from './LineChart'
import Api from '@/util/api'
import Apis from '@/util/apis'
import Constants from '@/util/constants'
import util from '@/util/util'

export default {
  name: 'ValueChart',
  components: { LineChart },
  data () {
    return {
      interval: '1',
      ready: false,
      chartData: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            // label: 'Data One',
            // backgroundColor: '#633cfc',
            data: [40, 39, 10, 40, 39, 80, 40],
            label: 'USD',
            borderColor: '#68E389',
            pointBackgroundColor: '#68E389',
            borderWidth: 2,
            pointBorderColor: '#68E389',
            backgroundColor: 'transparent',
            yAxisID: 'y-axis-usd',
            pointRadius: 1,
            pointHitRadius: 5
          },
          {
            // label: 'Data One',
            // backgroundColor: '#633cfc',
            data: ['8040.5', '8390.9', 10, 40, 39, 80, 40],
            label: 'BTC',
            borderColor: '#FF9900',
            pointBackgroundColor: '#FF9900',
            borderWidth: 2,
            pointBorderColor: '#FF9900',
            backgroundColor: 'transparent',
            yAxisID: 'y-axis-btc',
            pointRadius: 1,
            pointHitRadius: 5
          }
        ]
      },
      chartOptions: {
        animation: false,
        scales: {
          yAxes: [{
            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: 'right',
            id: 'y-axis-usd',
            gridLines: {
              drawOnChartArea: false // only want the grid lines for one axis to show up
            },
            ticks: {
              fontColor: '#68E389' // this here
            }
          }, {
            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: 'left',
            id: 'y-axis-btc',
            // grid line settings
            gridLines: {
              drawOnChartArea: false // only want the grid lines for one axis to show up
            },
            ticks: {
              fontColor: '#FF9900' // this here
            }
          }],
          // yAxes: [{
          //   ticks: {
          //     beginAtZero: false
          //   },
          //   gridLines: {
          //     display: true
          //   }
          // }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  watch: {
    '$store.state.sys.tradeExchange': function (newExToken) {
      this.updateValueChart()
    },
    '$route' (to, from) {
      // console.log(to)
      if (to.name === 'portfolio') {
        this.updateValueChart()
      }
    },
    '$store.state.assets.allexchs' () {
      this.updateValueChart()
    }
  },
  mounted () {
    this.updateValueChart()
  },
  methods: {
    updateValueChart () {
      if (!this.$store.state.sys.tradeExchange.ExchId) {
        return
      }
      let etid = this.$store.state.sys.tradeExchange.Id
      if (this.$store.state.assets.allexchs) {
        etid = 'ALL'
      }
      // console.log('updateValueChart, etid: ', etid)
      Apis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('user/chart', {
        params: {
          token: this.$store.state.sys.token,
          etid,
          interval: this.interval
        }
      }).then(response => {
        // console.log('response: ', response.data)
        const { status, data } = response
        if (status === Constants.http.OK) {
          if (data.labels === null || data.labels.length === 1) {
            this.ready = false
            return
          }
          this.chartData.labels = data.labels
          this.chartData.datasets[0].data = data.valueUsd
          this.chartData.datasets[1].data = data.valueBtc
          this.ready = true
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
